// extracted by mini-css-extract-plugin
export default {"overlayBg":"Overlay_overlayBg__ykL0H","overlay":"Overlay_overlay__TiG7U"};